import { ref } from 'vue';
import graphQl from '@/services/graphQl';

interface ParamsType {
  queryName: string;
  params: object;
  formatResp?: Function;
  initData?: any;
}

export function useGraphQLApi({
  queryName,
  params,
  formatResp = (obj) => obj,
  initData = null,
}: ParamsType) {
  const data = ref(initData);
  const error: any = ref(null);
  const isLoading = ref(false);

  const makegraphQLCall = async (queryName, params, formatResp) => {
    try {
      isLoading.value = true;
      const resp = await graphQl.query(queryName).params(params);
      data.value = formatResp(resp);
      error.value = null;
      isLoading.value = false;
    } catch (err: unknown) {
      console.log('error', err);
      error.value = err;
      data.value = null;
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    data,
    error,
    makegraphQLCall,
  };
}
